import { useNavigate } from 'react-router-dom';
import PrivacyPolicyPage from '../components/PrivacyPolicyPage';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function PrivacyPage() {
  const navigate = useNavigate();
  const {
    currentUser,
    userName,
    cartQty,
    handleLogout,
  } = useAppContext();

  return (
    <PrivacyPolicyPage
      onClose={() => navigate(ROUTES.ACCOUNT)}
      user={currentUser}
      userName={userName}
      userPhone={currentUser?.phoneNumber}
      onOpenOrders={() => navigate(ROUTES.ORDERS)}
      onOpenAddresses={() => navigate(ROUTES.ADDRESSES)}
      onOpenCart={() => navigate(ROUTES.CART)}
      cartCount={cartQty}
      onLogout={handleLogout}
      onHelp={() => navigate(ROUTES.HELP)}
    />
  );
}

export default PrivacyPage;
